const { usableValue } = require('../../utils')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {*} value
 * @returns {boolean}
 */
function digits ({ value }) {
  if (!usableValue(value)) return false

  const val = value
    .toString()
    .trim()
    .replace(/[^0-9.]/g, '')

  return !!val.length
}

module.exports = { digits }
